module.exports = __webpack_public_path__ + "static/img/stay-option-icon-sayna.2791ad07.svg";